import {Observable} from 'rxjs/Observable';
import {deleteCompleteAction, Types} from "./actions";

import * as ResourceApi from 'api/resources';

const submitDeleteEpic = ($action, store) => $action.ofType(Types.SUBMIT_DELETE)
    .mergeMap((action) => {
            let deleteState = store.getState().deleteConfirmation;
            let resourceId = deleteState.deleteResourceId;
            return ResourceApi.deleteResource(resourceId.type, resourceId.id, deleteState.additionalResourceIds, deleteState.additionalData)
                .mergeMap(({response: {modifiedBreak}}) => {
                  let postActions = deleteState.postDeleteActions.slice();
                  for (let post of postActions) {
                    post.modifiedBreak = modifiedBreak;
                  }
                  return Observable.of(deleteCompleteAction(), ...postActions)
                })
                .catch(err => Observable.of({
                    type: "ERROR",
                    error: err
                }))
        }
    );

export default [
    submitDeleteEpic
]



// WEBPACK FOOTER //
// ./public/pages/DeleteConfirmation/epics.js